const CONFIG = {
  development: {
    domain: "s-dev.shinshade.com",
    storefrontAccessToken: "b9b1ab6f003f9ba24f0be67691cda93c",
    products: {
      "ss930": { id: 7657204547686, name: "SS-930" },
      "ss980": { id: 7657204514918, name: "SS-980" },
      "ss1010": { id: 7657203662950, name: "SS-1010" },
      "ss1035": { id: 7657204482150, name: "SS-1035" },
      "ss1075": { id: 7657204449382, name: "SS-1075" },
      "ss1115": { id: 7657204416614, name: "SS-1115" },
      "ss1155": { id: 7657204383846, name: "SS-1155" },
      "ss1195": { id: 7657203859558, name: "SS-1195" },
      "ss1235": { id: 7657204351078, name: "SS-1235" },
      "ss1285": { id: 7657204318310, name: "SS-1285" },
      "ss1400": { id: 7657204285542, name: "SS-1400" },
      "ha1075": { id: 7713293631590, name: "HA-1075" },
      "ha1235": { id: 7657204220006, name: "HA-1235" },
      "ha1400": { id: 7657204220006, name: "HA-1400" },
      "nc980": { id: 7657204187238, name: "NC-980" },
      "nc1010": { id: "7657203630182", name: "NC-1010" },
      "nc1035": { id: 7657204121702, name: "NC-1035" },
      "nc1075": { id: 7657204056166, name: "NC-1075" },
      "nc1115": { id: 7657203957862, name: "NC-1115" },
      "nc1155": { id: 7657203957862, name: "NC-1155" },
      "ch980": { id: 7657204154470, name: "CH-980" },
      "ch1035": { id: 7657204088934, name: "CH-1035" },
      "ch1075": { id: 7713293664358, name: "CH-1075" },
      "ch1115": { id: 7657204023398, name: "CH-1115" },
      "ch1155": { id: 7657203925094, name: "CH-1155" },
      "ch1195": { id: 7657203892326, name: "CH-1195" },
      "ss": { id: 7657203794022, name: "SS金具" },
      "ha": { id: 7657203826790, name: "HA金具" },
      "cn": { id: 7657203761254, name: "NC金具" },
      "ch": { id: 7657203728486, name: "CH金具" },
    },
  },
  production: {
    domain: "shinshade.com",
    storefrontAccessToken: "9ca38c27aed95b53a75a0844ec28a58f",
    products: {
      "ss930": { id: 6717104685227, name: "SS-930" },
      "ss980": { id: 6718302748843, name: "SS-980" },
      "ss1010": { id: 6978397569195, name: "SS-1010" },
      "ss1035": { id: 6718309597355, name: "SS-1035" },
      "ss1075": { id: 6718319689899, name: "SS-1075" },
      "ss1115": { id: 6718321524907, name: "SS-1115" },
      "ss1155": { id: 6718324146347, name: "SS-1155" },
      "ss1195": { id: 6718366384299, name: "SS-1195" },
      "ss1235": { id: 6718326079659, name: "SS-1235" },
      "ss1285": { id: 6718327914667, name: "SS-1285" },
      "ss1400": { id: 6718330306731, name: "SS-1400" },
      "ha1075": { id: 8414231429291, name: "HA-1075" },
      "ha1235": { id: 6718333911211, name: "HA-1235" },
      "ha1400": { id: 8906409476267, name: "HA-1400" },
      "nc980": { id: 6718337843371, name: "NC-980" },
      "nc1010": { id: 7297118863531, name: "NC-1010" },
      "nc1035": { id: 6718342922411, name: "NC-1035" },
      "nc1075": { id: 6718347051179, name: "NC-1075" },
      "nc1115": { id: 8505501319339, name: "NC-1115" },
      "nc1155": { id: 6718358651051, name: "NC-1155" },
      "ch980": { id: 6718339842219, name: "CH-980" },
      "ch1035": { id: 6718344790187, name: "CH-1035" },
      "ch1075": { id: 7431556956331, name: "CH-1075" },
      "ch1115": { id: 6718350164139, name: "CH-1115" },
      "ch1155": { id: 6718360223915, name: "CH-1155" },
      "ch1195": { id: 6718363730091, name: "CH-1195" },
      "ss": { id: 6718381686955, name: "SS金具" },
      "ha": { id: 6718376706219, name: "HA金具" },
      "cn": { id: 6718384472235, name: "NC金具" },
      "ch": { id: 6718397153451, name: "CH金具" },
    },
  },
};

// 環境判定（URLベース）
const isDevelopment =
  window.location.hostname.includes("s-dev") ||
  window.location.hostname.includes("localhost") ||
  window.location.hostname.includes("127.0.0.1");
const currentConfig = isDevelopment ? CONFIG.development : CONFIG.production;



document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('purchase')) return;
  if (typeof currentConfig === 'undefined') {
    console.error('currentConfig is not defined. config.js を先に読み込んでください。');
    return;
  }

  const products = currentConfig.products;
  const productButtons = document.querySelectorAll('.js-product-purchasebutton');

  function getProductOptions(productId) {
    const product = products[productId] || { name: 'カートに入れる' };

    return {
      product: {
        iframe: false,
        contents: {
          img: false,
          title: false,
          price: false,
        },
        text: {
          button: `${product.name}をカートに入れる`,
        },
      },
      cart: {
        popup: false,
        text: {
          title: 'カート',
          total: '小計',
          empty: 'カートの中は空です。',
          notice: '配送料と割引は、チェックアウト時に追加されます。',
          button: 'チェックアウトへ進む',
        },
      },
    };
  }

  function loadShopifyBuyButton(callback) {
    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      callback();
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function initShopifyBuyButtons() {
    const client = ShopifyBuy.buildClient({
      domain: currentConfig.domain,
      storefrontAccessToken: currentConfig.storefrontAccessToken,
    });

    ShopifyBuy.UI.onReady(client).then(function (ui) {
      productButtons.forEach(function (button) {
        const productId = button.dataset.productId;
        const product = products[productId];

        if (!product) {
          console.warn(`Product config not found: ${productId}`);
          return;
        }

        ui.createComponent('product', {
          id: product.id,
          node: button,
          moneyFormat: '%C2%A5%7B%7Bamount_no_decimals%7D%7D',
          options: getProductOptions(productId),
        });
      });
    });
  }

  loadShopifyBuyButton(initShopifyBuyButtons);
});